import { FunctionComponent } from 'preact'
import RatingField from './RatingField'
import CheckboxSelectField from './CheckboxSelectField'
import NpsField from './NpsField'
import RadioSelectField from './RadioSelectField'
import CsatField from './CsatField'
import CesField from './CesField'
import EndingField from './EndingField'
import WelcomeField from './WelcomeField'
import DescriptionField from './DescriptionField'
import CtaField from './CtaField'
import TextAreaField from './TextAreaField'
import TextField from './TextField'

export const FieldComponentMap: { [key: string]: FunctionComponent<any> } = {
  TextArea: TextAreaField,
  TextField: TextField,
  RatingField,
  CesField,
  CsatField,
  CheckBox: CheckboxSelectField,
  NpsField,
  RadioButton: RadioSelectField,
  EndingField,
  WelcomeField,
  DescriptionField,
  CtaField,
}
